import { Route, Switch } from 'react-router';
import { notificationsRoutes } from './constants';

export const NotificationsRoutes = () => {

  return (
		<Switch>
			{
				notificationsRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}